
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"120","height":"120","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.44 78.772a3.53 3.53 0 013.471-2.89h86.837a3.529 3.529 0 013.472 4.165l-3.748 20.471a3.53 3.53 0 01-4.114 2.835l-84-15.53a3.53 3.53 0 01-2.829-4.11l.911-4.941zm14.338 4.17l69.387 12.827 2.349-12.828H29.778z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.588 27.176a3.53 3.53 0 013.53-3.529h104.117a3.53 3.53 0 013.53 3.53v52.235a3.53 3.53 0 01-3.53 3.53H8.118a3.53 3.53 0 01-3.53-3.53V27.176zm7.06 3.53v45.176h97.058V30.706H11.647z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M76.235 53.294c0 8.967-7.268 16.235-16.235 16.235-8.966 0-16.235-7.268-16.235-16.235 0-8.966 7.269-16.235 16.235-16.235 8.967 0 16.235 7.269 16.235 16.235zm-10.588 7.412c.706-1.059 1.412-2.118 1.412-3.53 0-1.058-.353-2.117-1.059-3.176-.706-1.059-2.118-1.765-3.882-2.47l-1.06-.354v-5.294c1.766 0 3.177.353 4.589 1.06l1.059-2.824c-1.765-.706-3.53-1.06-5.647-1.06v-2.47H58.94v2.47c-1.765.354-3.176.707-4.235 1.766-1.059 1.058-1.765 2.117-1.765 3.529 0 1.059.353 2.118 1.059 2.823.706 1.06 4.941 2.824 4.941 2.824v5.647c-1.059 0-2.117 0-3.176-.353-1.06-.353-2.118-.706-2.824-1.059v3.177c1.412.706 3.53 1.059 6 1.059v3.176h2.118v-3.176c2.117-.353 3.53-.706 4.588-1.765zm-8.47-10.941c-.353-.353-.706-.706-.706-1.412s.353-1.059.706-1.412c.352-.353 1.058-.706 1.764-.706v4.589c-.706-.353-1.412-.706-1.765-1.06zm5.647 6.353c.352.353.705.706.705 1.411 0 1.06-.706 1.765-2.823 2.118V55.06c1.059.353 1.765.706 2.117 1.059z","fill":"#fff"}})])
          )
        }
      }
    